/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'delete-bucket',
  components: {},
  props: ['removeBucketID'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getBucketListAgainMethod(){
      this.$store.dispatch('getBucketListOfAwerackFun').then((res)=>{
      }).catch((err) => {})
    },
    confirmRemoveBucketMethod(){
      this.$store.dispatch('removeBucketOfAwerackDetailsFun',{id:this.removeBucketID}).then((res)=>{
        toast.success(res.data.msg);
        this.getBucketListAgainMethod()
        this.closeRemoveBucketPopup()
      }).catch((err)=>{
      })
    },
    closeRemoveBucketPopup(){
      bus.$emit('removeBucketPopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  }
}


